'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { tweet_loading_tweets, tweet_empty_noTweets, tweet_loading_loadMore, tweet_actions_loadMore } from '@paraglide/messages';
import styled from '@emotion/styled';
import { TweetCard } from '../TweetCard';
const ListContainer = styled.div`
  background: var(--theme-surface, #ffffff);
  border: 1px solid var(--theme-border, #e1e8ed);
  border-radius: 16px;
  overflow: hidden;
`;
const LoadingContainer = styled.div`
  padding: 32px;
  text-align: center;
  color: var(--theme-text-secondary, #657786);
`;
const EmptyContainer = styled.div`
  padding: 48px 32px;
  text-align: center;
  color: var(--theme-text-secondary, #657786);
`;
const LoadMoreButton = styled.button`
  width: 100%;
  padding: 16px;
  border: none;
  background: var(--theme-surface-hover, #f7f9fa);
  color: var(--theme-primary, #1da1f2);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: var(--theme-surface-active, #e1e8ed);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export function TweetList({ tweets, loading = false, onLoadMore, hasMore = false, onTweetAction }) {
    const handleTweetAction = (action, tweet)=>{
        onTweetAction?.(action, tweet);
    };
    if (loading && tweets.length === 0) {
        return /*#__PURE__*/ _jsx(ListContainer, {
            children: /*#__PURE__*/ _jsx(LoadingContainer, {
                children: /*#__PURE__*/ _jsx("div", {
                    children: tweet_loading_tweets()
                })
            })
        });
    }
    if (tweets.length === 0) {
        return /*#__PURE__*/ _jsx(ListContainer, {
            children: /*#__PURE__*/ _jsx(EmptyContainer, {
                children: /*#__PURE__*/ _jsx("div", {
                    children: tweet_empty_noTweets()
                })
            })
        });
    }
    return /*#__PURE__*/ _jsxs(ListContainer, {
        children: [
            tweets.map((tweet)=>/*#__PURE__*/ _jsx(TweetCard, {
                    tweet: tweet,
                    onLike: (tweetId)=>handleTweetAction('like', tweet),
                    onRetweet: (tweetId)=>handleTweetAction('retweet', tweet),
                    onReply: (tweet)=>handleTweetAction('reply', tweet),
                    onDelete: (tweetId)=>handleTweetAction('delete', tweet)
                }, tweet.id)),
            hasMore && /*#__PURE__*/ _jsx(LoadMoreButton, {
                onClick: onLoadMore,
                disabled: loading,
                children: loading ? tweet_loading_loadMore() : tweet_actions_loadMore()
            })
        ]
    });
}
